import React from "react";
import { connect } from "react-redux";
import {
  FaTrash,
  FaGripVertical,
  FaChevronLeft,
  FaChevronRight,
} from "react-icons/fa";
import { Translate, I18n } from "react-redux-i18n";

import alertify from "alertifyjs";
import "../components/styles/Alertify.css";
import "../components/styles/AlertifyTheme.css";
import "../components/styles/Alertify.min.css";
import "../components/styles/AlertifyTheme.min.css";

import * as actions from "../redux/actions/mediaActions";
import MiniLoader from "../components/MiniLoader";
import { convertToWebp } from "../utils/imageUtils";

function isImageMedia(item) {
  return (item?.Type || "").toLowerCase() === "image";
}

class GaleryItem extends React.Component {
  render() {
    const {
      item,
      index,
      total,
      reordering,
      onRemove,
      onMoveLeft,
      onMoveRight,
      onDragStart,
      onDragOver,
      onDrop,
    } = this.props;

    return (
      <div
        className={`panel-edit-ad-gallery__item${
          reordering ? " panel-edit-ad-gallery__item--reordering" : ""
        }`}
        draggable={!reordering}
        onDragStart={onDragStart}
        onDragOver={onDragOver}
        onDrop={onDrop}
      >
        <span className="panel-edit-ad-gallery__position">{index + 1}</span>
        <span className="panel-edit-ad-gallery__drag" aria-hidden="true">
          <FaGripVertical />
        </span>
        <img
          src={item.Url}
          className="panel-edit-ad-gallery__img"
          alt="Goder"
          draggable={false}
        />
        <div className="panel-edit-ad-gallery__actions">
          <button
            type="button"
            className="panel-edit-ad-gallery__move"
            onClick={onMoveLeft}
            disabled={reordering || index === 0}
            aria-label={I18n.t("ad_gallery_move_left")}
          >
            <FaChevronLeft />
          </button>
          <button
            type="button"
            className="panel-edit-ad-gallery__move"
            onClick={onMoveRight}
            disabled={reordering || index === total - 1}
            aria-label={I18n.t("ad_gallery_move_right")}
          >
            <FaChevronRight />
          </button>
          <button
            type="button"
            className="panel-edit-ad-gallery__remove"
            onClick={onRemove}
            disabled={reordering}
            aria-label="Remove"
          >
            <FaTrash />
          </button>
        </div>
      </div>
    );
  }
}

class PanelEditGalery extends React.Component {
  state = {
    image: "",
    file: "",
    mediaHydrated: false,
    dragIndex: null,
  };

  componentDidMount() {
    this.syncGallery();
  }

  componentDidUpdate(prevProps) {
    if (this.props.ad?.Id && this.props.ad.Id !== prevProps.ad?.Id) {
      this.setState({ mediaHydrated: false });
      this.syncGallery();
    }
  }

  componentWillUnmount() {
    this.props.ClearMedia();
  }

  syncGallery = async () => {
    const adId = this.props.ad?.Id;
    if (!adId) return;

    const adMedia = Array.isArray(this.props.ad?.Media)
      ? this.props.ad.Media
      : [];

    if (adMedia.length > 0) {
      this.props.SetMediaList(adMedia);
      this.setState({ mediaHydrated: true });
    } else {
      this.props.ClearMedia();
    }

    await this.fetchMedia(adId);
  };

  fetchMedia = async (adId) => {
    try {
      await this.props
        .LoadMedia(this.props.token, {
          goder_id: adId,
          id: this.props.user_id,
        })
        .then(() => {
          if (this.props.error) {
            alertify.warning(I18n.t(this.props.error));
          } else {
            this.setState({ mediaHydrated: true });
          }
        });
    } catch (error) {
      console.log(error);
    }
  };

  getImages = () => {
    const adMedia = Array.isArray(this.props.ad?.Media)
      ? this.props.ad.Media
      : [];
    const sourceList = this.state.mediaHydrated
      ? this.props.mediaList
      : this.props.mediaList.length > 0
        ? this.props.mediaList
        : adMedia;

    return sourceList.filter(isImageMedia);
  };

  persistImageOrder = async (images) => {
    const adId = this.props.ad?.Id;
    if (!adId || images.length < 2) return;

    const previousList = this.props.mediaList;
    const nonImages = previousList.filter((item) => !isImageMedia(item));
    const nextList = [...images, ...nonImages];
    this.props.SetMediaList(nextList);

    const result = await this.props.ReorderMedia(this.props.token, {
      goder_id: adId,
      id: this.props.user_id,
      order: images.map((item) => item.Id),
    });

    if (!result?.success) {
      this.props.SetMediaList(previousList);
      alertify.warning(I18n.t(result?.error || this.props.error_update || "try_later"));
      await this.fetchMedia(adId);
    }
  };

  moveImage = async (fromIndex, toIndex) => {
    const images = this.getImages();
    if (toIndex < 0 || toIndex >= images.length || fromIndex === toIndex) {
      return;
    }

    const nextImages = [...images];
    const [moved] = nextImages.splice(fromIndex, 1);
    nextImages.splice(toIndex, 0, moved);
    await this.persistImageOrder(nextImages);
  };

  onDragStart = (index) => {
    this.setState({ dragIndex: index });
  };

  onDragOver = (event) => {
    event.preventDefault();
  };

  onDrop = async (index) => {
    const { dragIndex } = this.state;
    this.setState({ dragIndex: null });

    if (dragIndex === null || dragIndex === index) {
      return;
    }

    await this.moveImage(dragIndex, index);
  };

  onClickRemove = async (item) => {
    try {
      await this.props
        .RemoveMedia(this.props.token, {
          media_id: item.Id,
          id: this.props.user_id,
        })
        .then(() => {
          if (this.props.error_update) {
            alertify.warning(I18n.t(this.props.error_update));
          }
        });
    } catch (error) {
      console.log(error);
    }
  };

  onChangeImageAd = async (e) => {
    const adId = this.props.ad?.Id;
    if (!adId) return;

    if (this.props.mediaList.length >= 5) {
      alertify.alert(
        I18n.t("warning"),
        I18n.t("warning_max_img"),
        function () {}
      );
      return;
    }

    const file = e.target.files[0];
    if (!file) return;

    const webpFile = await convertToWebp(file);
    const reader = new FileReader();

    reader.onloadend = () => {
      this.setState({
        file: webpFile,
        image: reader.result,
      });
    };

    reader.readAsDataURL(webpFile);

    const params = new FormData();
    params.append("goder_id", adId);
    params.append("id", this.props.user_id);
    params.append("image", webpFile);

    await this.props.UpdateMedia(this.props.token, params).then(() => {
      if (this.props.error_update) {
        alertify.warning(I18n.t(this.props.error_update));
      } else {
        this.setState({ mediaHydrated: true });
      }
    });

    e.target.value = "";
  };

  render() {
    const images = this.getImages();
    const isLoading = this.props.loading && !this.state.mediaHydrated && images.length === 0;
    const reordering = this.props.reordering;

    return (
      <section className="panel-edit-ad-card">
        <h2 className="panel-edit-ad-card__title">
          <Translate value="ad_galery" />
        </h2>

        {images.length > 1 && (
          <p className="panel-edit-ad-gallery__hint">
            <Translate value="ad_gallery_order_hint" />
          </p>
        )}

        {isLoading && (
          <div className="panel-edit-ad-gallery__loading">
            <MiniLoader />
          </div>
        )}

        {!isLoading && images.length > 0 && (
          <div className="panel-edit-ad-gallery__grid">
            {images.map((item, index) => (
              <GaleryItem
                item={item}
                key={item.Id}
                index={index}
                total={images.length}
                reordering={reordering}
                onRemove={() => {
                  this.onClickRemove(item);
                }}
                onMoveLeft={() => {
                  this.moveImage(index, index - 1);
                }}
                onMoveRight={() => {
                  this.moveImage(index, index + 1);
                }}
                onDragStart={() => {
                  this.onDragStart(index);
                }}
                onDragOver={this.onDragOver}
                onDrop={() => {
                  this.onDrop(index);
                }}
              />
            ))}
          </div>
        )}

        {!isLoading && images.length === 0 && (
          <p className="panel-edit-ad-gallery__empty">
            <Translate value="ad_gallery_empty" />
          </p>
        )}

        {(this.props.loading_image || reordering) && <MiniLoader />}

        <div className="panel-edit-ad-gallery__footer">
          <Translate value="warning_max_img" />
          <input
            className="panel-edit-ad-gallery__upload"
            accept="image/*"
            type="file"
            name="image"
            id="panel_edit_ad_image"
            onChange={this.onChangeImageAd}
            disabled={reordering}
          />
          <label
            htmlFor="panel_edit_ad_image"
            className="panel-edit-ad-gallery__upload-btn"
          >
            <Translate value="ad_load_image" />
          </label>
        </div>
      </section>
    );
  }
}

function mapStateToProps(reducer) {
  return {
    user_id: reducer.session.auth.id,
    token: reducer.session.auth.access_token,
    ad: reducer.ad.item,

    error: reducer.media.error,
    loading: reducer.media.loading,
    mediaList: reducer.media.list,

    error_update: reducer.media.error_update,
    loading_image: reducer.media.loadingFile,
    reordering: reducer.media.reordering,
  };
}

const mapDispatchToProps = (dispatch) => ({
  RemoveMedia: (token, params) =>
    dispatch(actions.deleteItem({ token, params })),
  LoadMedia: (token, params) =>
    dispatch(actions.loadList({ token, params })),
  UpdateMedia: (token, params) => dispatch(actions.newItem({ token, params })),
  ReorderMedia: (token, params) =>
    dispatch(actions.reorderList({ token, params })),
  SetMediaList: (list) => dispatch(actions.setMediaList(list)),
  ClearMedia: () => dispatch(actions.clearMediaList({})),
});

export default connect(mapStateToProps, mapDispatchToProps)(PanelEditGalery);
